import JSZip from 'jszip';
import { logError, logInfo } from '../logger';
import { parseGeoJSON } from './geojsonParser';
import { parseKML } from './kmlParser';
import { parseGPX } from './gpxParser';
import { processZipWithImages } from './zipImporter';
import { validateGeoJSON } from './geojsonValidator';

export const importData = async (file) => {
  try {
    logInfo(`Starting import of file: ${file.name}, type: ${file.type}`);
    const extension = file.name.split('.').pop().toLowerCase();
    let content, contentType;
    let result;

    switch (extension) {
      case 'geojson':
      case 'json':
        content = await file.text();
        logInfo('Parsing GeoJSON content');
        const validation = validateGeoJSON(JSON.parse(content));
        if (!validation.isValid) {
          logError('GeoJSON validation failed:', validation.error);
          throw new Error(validation.error);
        }
        logInfo('GeoJSON validation successful');
        result = await parseGeoJSON(JSON.parse(content));
        contentType = 'geojson';
        break;

      case 'kml':
        content = await file.text();
        logInfo('Parsing KML content');
        result = await parseKML(content);
        contentType = 'kml';
        break;

      case 'kmz':
        logInfo('Parsing KMZ content');
        const zip = new JSZip();
        const zipContents = await zip.loadAsync(file);
        const kmlFile = zipContents.file(/\.kml$/i)[0];
        if (!kmlFile) {
          logError('No KML file found in KMZ archive');
          throw new Error('No KML file found in KMZ archive');
        }
        content = await kmlFile.async('text');
        result = await parseKML(content);
        contentType = 'kmz';
        break;

      case 'gpx':
        content = await file.text();
        logInfo('Parsing GPX content');
        result = await parseGPX(content);
        contentType = 'gpx';
        break;

      case 'zip': // For Shapefiles or ZIP with GeoJSON and images
        logInfo('Parsing ZIP content');
        contentType = 'zip';
        result = await processZipWithImages(file);
        break;

      default:
        logError(`Unsupported file format: ${extension}`);
        throw new Error(`Unsupported file format: ${extension}`);
    }

    if (!result) {
      throw new Error('No data was parsed from the file');
    }
    
    // Ensure we have arrays for all properties
    result.points = result.points || [];
    result.routes = result.routes || [];
    result.layers = result.layers || [];
    result.images = result.images || [];
    
    // Extract unique layers from points if none provided
    if (!result.layers.length) {
      const layers = [...new Set(result.points.map(point => point.layer || 'default'))];
      result.layers = layers;
    }
    
    logInfo(`Import successful: ${result.points.length} POIs, ${result.routes.length} routes`);
    
    return result;
  } catch (error) {
    logError('Import failed:', error);
    throw error;
  }
}